import React from 'react';

import { createClassName } from 'utils/createClassName';

import './gridStyles.css';

type Props = {
  axis?: 'x' | 'y';
  primaryAlign?: 'start' | 'center' | 'end' | 'apart' | 'even' | 'stretch';
  secondaryAlign?: 'start' | 'center' | 'end' | 'apart' | 'even' | 'stretch';
  gap?: number;
};

export const GridContainerComponent: React.FC<Props> = (props) => {
  const {
    children,
    axis,
    primaryAlign = 'start',
    secondaryAlign = 'start',
    gap,
  } = props;

  const className = createClassName('gridContainer')({
    axis,
    primaryAlign,
    secondaryAlign,
  });

  return (
    <div className={className} style={{ gap }}>
      {children}
    </div>
  );
};
